import { router } from './index';

// 主頁 Views
import Layout from '@/layouts/Layout.vue';
import Dashboard from '@/views/Dashboard.vue';
import { DashboardOutlined } from '@ant-design/icons-vue';

// 私有路由
import {
    permissionFolderRoute,
    permissionChildrenRoutes
} from './routes/permission';

// 權限 API
// import { userMe } from '@/api/admin-user/userMe';
// import { menuFunction } from '@/api/permission/menuFunciton';

let hasLoadedPrivateRoutes = false;
let isSuperAdmin = false;

export let dynamicRoutes = [];

// 分組排序用，選單渲染時會依照此順序渲染
const modulesConfig = [
    { folder: permissionFolderRoute, children: permissionChildrenRoutes }
];

// 權限管理用，所有後端定義的路由權限 key 都會在這裡（除了個人帳號管理 - 帳號信息 & 登入日誌）
const allRoutesMap = {
    '00001111': [
        {
            type: 'folder',
            route: permissionFolderRoute // 權限管理
        }
    ],
    '00002222': [
        {
            type: 'child',
            route: permissionChildrenRoutes[0], // 帳號管理
            parent: '771921f1' // (權限管理)
        }
    ],
    '00003333': [
        {
            type: 'child',
            route: permissionChildrenRoutes[1], // 角色管理
            parent: '771921f1' // (權限管理)
        }
    ]
};

function filterRoutesByPermissions(permissionList) {
    console.log(
        '%c[setupRouterWithAuth]',
        'font-weight: bold; color: #2196F3',
        'check permissionList: ',
        permissionList
    );
    console.log(
        '%c[setupRouterWithAuth]',
        'font-weight: bold; color: #2196F3',
        'allRoutesMap: ',
        allRoutesMap
    );

    // 1. 扁平化所有 configs
    const configs = permissionList.flatMap((key) => allRoutesMap[key] || []);
    console.log(
        '%c[setupRouterWithAuth]',
        'font-weight: bold; color: #2196F3',
        'flattened configs: ',
        configs
    );

    // 2. 收集所有 folder（clone）到 Map
    const folderMap = new Map();
    configs.forEach(({ type, route }) => {
        if (type === 'folder' && !folderMap.has(route.path)) {
            console.log(
                '%c[setupRouterWithAuth]',
                'font-weight: bold; color: #2196F3',
                'adding folder route: ',
                route
            );
            folderMap.set(route.path, { ...route, children: [] });
        }
    });

    // 3. 分配每個 child 到它所屬的 folder
    configs
        .filter((c) => c.type === 'child')
        .forEach(({ route }) => {
            const mod = modulesConfig.find((m) =>
                m.children.some((child) => child.name === route.name)
            );
            if (!mod) return;

            if (!folderMap.has(mod.folder.path)) {
                console.log(
                    '%c[setupRouterWithAuth]',
                    'font-weight: bold; color: #2196F3',
                    'lazy adding folder for child: ',
                    mod.folder
                );
                folderMap.set(mod.folder.path, { ...mod.folder, children: [] });
            }
            const parent = folderMap.get(mod.folder.path);
            if (!parent.children.find((r) => r.name === route.name)) {
                console.log(
                    '%c[setupRouterWithAuth]',
                    'font-weight: bold; color: #2196F3',
                    'adding child route:',
                    route,
                    'to folder',
                    parent.path
                );
                parent.children.push(route);
            }
        });

    // 4. 按照 modulesConfig.children 順序，對每個 folder.children 做一次排序
    modulesConfig.forEach(({ folder, children: templateChildren }) => {
        const f = folderMap.get(folder.path);
        if (f) {
            console.log(
                '%c[setupRouterWithAuth]',
                'font-weight: bold; color: #2196F3',
                'sorting children for folder:',
                f.path
            );
            f.children.sort((a, b) => {
                return (
                    templateChildren.findIndex((c) => c.name === a.name) -
                    templateChildren.findIndex((c) => c.name === b.name)
                );
            });
        }
    });

    // 5. 最終結果，按 modulesConfig 裡 folder 順序輸出
    const result = modulesConfig
        .map((m) => folderMap.get(m.folder.path))
        .filter((f) => f && f.children.length > 0);

    console.log(
        '%c[setupRouterWithAuth]',
        'font-weight: bold; color: #2196F3',
        'final folders:',
        result
    );
    return result;
}

export async function setupRouterWithAuth() {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken || hasLoadedPrivateRoutes) return;

    // try {
    //     const response = await userMe();
    //     console.log('userMe API Response: ', response);

    //     if (response.status === 'success') {
    //         const permission = response.data.functions;

    //         // 確認是否是 super admin
    //         // 假如是的 super admin，在 permission list 加上前端預設權限
    //         // 用於顯示 機器人管理/ck 管理/CDN 設置
    //         // TODO: 待後端新增以上權限後再刪除 '00001111', '00002222', '00003333'...
    //         isSuperAdmin = response.data.role === '最高管理者';

    //         if (isSuperAdmin) {
    //             permission.push(...['00001111', '00002222', '00003333']);
    //         }

    //         console.log(
    //             '%c[setupRouterWithAuth]',
    //             'font-weight: bold; color: #2196F3',
    //             'Final permission list: ',
    //             permission
    //         );

    //         const matchedRoutes = filterRoutesByPermissions(permission);

    //         // 動態註冊路由
    //         dynamicRoutes = [
    //             {
    //                 path: '/',
    //                 component: Layout,
    //                 redirect: '/dashboard',
    //                 children: [
    //                     {
    //                         path: 'dashboard',
    //                         component: Dashboard,
    //                         name: 'Dashboard',
    //                         meta: {
    //                             title: '控制台',
    //                             icon: DashboardOutlined
    //                         }
    //                     },
    //                     {
    //                         ...adminFolderRoute,
    //                         children: [
    //                             adminChildrenRoutes[0],
    //                             ...(permission.includes('23e4d01c')
    //                                 ? [adminChildrenRoutes[1]]
    //                                 : [])
    //                         ]
    //                     },
    //                     ...matchedRoutes
    //                 ]
    //             }
    //         ];
    //         dynamicRoutes.forEach((route) => router.addRoute(route));
    //         hasLoadedPrivateRoutes = true;
    //     }
    // } catch (error) {
    //     console.error('初始化路由失敗', error);
    // }
}
